import { Component, OnInit } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ClientMerchantsService } from 'src/app/services/apiclient/clientmerchants/clientmerchants.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CurrencyService } from 'src/app/services/manage/currency/currency.service';
import { ClientRefillsService } from 'src/app/services/apiclient/clientrefills/clientrefills.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmBlockCardComponent } from '../../dialogs/confirm-block-card/confirm-block-card.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cashless-options',
  templateUrl: './cashless-options.component.html',
  styleUrls: ['./cashless-options.component.css']
})
export class CashlessOptionsComponent implements OnInit {

  currMerchant: any;

  merchantClient: any;

  respCols: number = this.media.isActive("xs") ? 1 : 2;
  respHeight: number = this.media.isActive("xs") ? 100 : 200;

  loaders: any = {
    page: true
  };

  statusMessage: string =   this.translate.instant('cashlessOptionComponent.messageLoaderGetOptions');
  successMessage: string|any;
  errorMessage: string|any;

  constructor(
    private media: MediaObserver,
    private clientMerchantApi: ClientMerchantsService,
    private router: Router,
    private route: ActivatedRoute,
    private currencyMng: CurrencyService,
    private refillsApi: ClientRefillsService,
    private dialog: MatDialog,
    public translate: TranslateService
  ) {
    this.manageResp();
  }

  ngOnInit() {


    this.route.params.subscribe((params:any) => {


      if (params.merchantId) {

        this.clientMerchantApi.getMerchant(params.merchantId).subscribe(merchant => {

          this.currMerchant = merchant;

          this.currencyMng.setCurrCurrency(merchant.currency);

          this.clientMerchantApi.getMerchantClient(params.merchantId).subscribe(client => {


            // if (!this.checkMerchantOptions(15) && client.credit_amount === 0) {
            //   //a changer Cagnotte en ligne this.checkMerchantOptions(2)

            //   this.router.navigate(["/404", "L'Option cashless n'est pas active sur ce commerçant"]);
            // }

            this.merchantClient = client;

            this.loaders.page = false;

          });

        });

      } else {

        this.router.navigate(["/404", this.translate.instant('error404.Urlincomplet')]);

      }

    });
  }

  checkMerchantOptions(optionId: number) {
    // 14: Order 15: Cashless
    return this.currMerchant.options.includes(optionId) ? true : false;
  }

  goRecharge(): void {
    this.router.navigate(["/home/recharge" + "/" + this.currMerchant.id_user]);
  }

  goHistory(): void {
    this.router.navigate(["/home/refills" + "/" + this.currMerchant.id_user]);
  }

  openConfirmBlockCard(): void {
    const block = (this.merchantClient.archive === 0) ? true : false;
    const myConf = new MatDialogConfig();
    myConf.autoFocus = false;
    myConf.data = {
      block: block
    };
    this.media.isActive("xs") ? myConf.width = "100%" : myConf.width = "500px";
    const myDial = this.dialog.open(ConfirmBlockCardComponent, myConf);
    myDial.afterClosed().subscribe((result) => {
      if (result) {
        block ? this.blockCard() : this.unblockCard();
      }
    });
  }

  goBack(): void {
    this.router.navigate(["/home/merchantOptions/" + this.currMerchant.id_user]);
  }

  blockCard(): void {

    this.successMessage = null;
    this.errorMessage = null;

    this.statusMessage = this.translate.instant('cashlessOptionComponent.messageLoaderBlockCard');
    this.loaders.page = true;

    this.refillsApi.blockCard(this.currMerchant.id_user).then(data => {

      if (data.code === 0) {

        // Update merchant client
        this.merchantClient = data.client_user;
        this.successMessage =this.translate.instant('cashlessOptionComponent.messageLoaderBlockCardSuccess');

      } else {

        this.errorMessage = data.message;

      }

      this.loaders.page = false;

    });
  }

  unblockCard(): void {
    this.successMessage = null;
    this.errorMessage = null;
    this.statusMessage =this.translate.instant('cashlessOptionComponent.messageLoaderUnblockCard');
    this.loaders.page = true;

    this.refillsApi.unblockCard(this.currMerchant.id_user).then(data => {

      if (data.code === 0) {

        this.merchantClient = data.client_user;
        this.successMessage =this.translate.instant('cashlessOptionComponent.messageLoaderUnblockCardSuccess');

      } else {

        this.errorMessage = data.message;

      }

      this.loaders.page = false;

    });

  }

  manageResp() {
    this.media.asObservable().subscribe((media:any) => {
      this.respCols = (media.mqAlias === "xs") ? 1 : 2;
      this.respHeight = this.media.isActive("xs") ? 100 : 200;
    });
  }

}
